import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  CONTENT: null,
  EXTENSION_RESOURCE: null,
  LAYOUT: null,
  CUSTOM_WIDGET: null
}));